import { Text } from '@ksyos/design-system';
import { SmallNullableInputText } from '@frontend/components/elements/common';

interface IOorkV1ReadOrEditInputField {
    error?: string;
    isReadOnly: boolean;
    onChange: (value: string | null) => void;
    onDoValidate?: () => void;
    placeholder?: string;
    value: string | null;
}

export function OorkV1ReadOrEditInputField(props: IOorkV1ReadOrEditInputField) {
    if (!props.isReadOnly) {
        return <SmallNullableInputText {...props} />;
    } else {
        return <Text size="xs">{props.value ?? ''}</Text>;
    }
}
